import React, { useState } from 'react';
import FeedPage from './pages/FeedPage';
import './styles/main.scss'
import LoginPage from './pages/LoginPage';
import { EnceladusBackground } from './components/EnceladusBackground';
import { ScrollToTopButton } from './components/ScrollToTopButton';

const PASSWORD = '20082000'

const App: React.FC = () => {
  const [loggedIn, setLoggedIn] = useState(false)

  if (!loggedIn) {
    return (
      <>
        <EnceladusBackground />
        <LoginPage onLogin={() => setLoggedIn(true)} passwordValue={PASSWORD} loginValue='pavlodar'/>
      </>
    )
  }

  return (
    <>
      <EnceladusBackground />
      <ScrollToTopButton />
      <div className="app-container">
        <FeedPage />
      </div>
    </>
  );
};

export default App;